module.exports = __webpack_public_path__ + "media/images/award-badges-mobile-245242a02693a137e1687c7ddd7bd9a1.svg";